import { render } from "./daftar-klien-popup.vue?vue&type=template&id=67913ca2&ts=true"
import script from "./daftar-klien-popup.vue?vue&type=script&lang=ts"
export * from "./daftar-klien-popup.vue?vue&type=script&lang=ts"

import "./daftar-klien-popup.vue?vue&type=style&index=0&id=67913ca2&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__